// Analytics: thin wrapper over the GTM dataLayer (container GTM-W3PB5V6B is
// loaded from index.html, same as the classic editor and the marketing site).
// Never throws, never blocks — analytics failures are invisible to the user.

declare global {
  interface Window { dataLayer?: Record<string, unknown>[] }
}

export function trackEvent(event: string, params: Record<string, unknown> = {}): void {
  try {
    ;(window.dataLayer = window.dataLayer || []).push({ event, ...params })
  } catch { /* blocked/absent dataLayer */ }
}
